module.exports = __webpack_public_path__ + "img/taiwanRailway-doc.3b21a1e1.jpg";